let activeCurrency = 'USD';
export const setActiveCurrency = (currency) => { activeCurrency = currency || 'USD'; };
export const money = (n) => new Intl.NumberFormat(activeCurrency === 'INR' ? 'en-IN' : 'en-US', { style: 'currency', currency: activeCurrency, maximumFractionDigits: 0 }).format(n);

export const initials = (name) => {
  const words = (name || '').split(' ').filter(Boolean);
  return (words.length > 1 ? words.map((x) => x[0]).join('').slice(0, 2) : (name || '').slice(0, 2)).toUpperCase();
};

export const locationData = {
  'United States': {
    'Alabama': ['Birmingham', 'Montgomery', 'Huntsville'],
    'Alaska': ['Anchorage', 'Juneau'],
    'Arizona': ['Phoenix', 'Tucson', 'Scottsdale'],
    'Arkansas': ['Little Rock', 'Fayetteville'],
    'California': ['Los Angeles', 'San Francisco', 'San Diego', 'San Jose', 'Belmont'],
    'Colorado': ['Denver', 'Colorado Springs', 'Boulder'],
    'Connecticut': ['Hartford', 'Stamford', 'New Haven'],
    'Delaware': ['Wilmington', 'Dover'],
    'District of Columbia': ['Washington'],
    'Florida': ['Miami', 'Orlando', 'Tampa', 'Jacksonville'],
    'Georgia': ['Atlanta', 'Savannah', 'Augusta'],
    'Hawaii': ['Honolulu'],
    'Idaho': ['Boise'],
    'Illinois': ['Chicago', 'Highland Park', 'Naperville'],
    'Indiana': ['Indianapolis', 'Fort Wayne'],
    'Iowa': ['Des Moines', 'Cedar Rapids'],
    'Kansas': ['Wichita', 'Overland Park'],
    'Kentucky': ['Louisville', 'Lexington'],
    'Louisiana': ['New Orleans', 'Baton Rouge'],
    'Maine': ['Portland', 'Augusta'],
    'Maryland': ['Baltimore', 'Rockville'],
    'Massachusetts': ['Boston', 'Cambridge', 'Worcester'],
    'Michigan': ['Detroit', 'Ann Arbor', 'Grand Rapids'],
    'Minnesota': ['Minneapolis', 'Saint Paul'],
    'Mississippi': ['Jackson', 'Gulfport'],
    'Missouri': ['Kansas City', 'St. Louis'],
    'Montana': ['Billings', 'Missoula'],
    'Nebraska': ['Omaha', 'Lincoln'],
    'Nevada': ['Las Vegas', 'Reno'],
    'New Hampshire': ['Manchester', 'Nashua'],
    'New Jersey': ['Hoboken', 'Newark', 'Jersey City'],
    'New Mexico': ['Albuquerque', 'Santa Fe'],
    'New York': ['New York City', 'Buffalo', 'Albany'],
    'North Carolina': ['Charlotte', 'Raleigh', 'Durham'],
    'North Dakota': ['Fargo', 'Bismarck'],
    'Ohio': ['Columbus', 'Cleveland', 'Cincinnati'],
    'Oklahoma': ['Oklahoma City', 'Tulsa'],
    'Oregon': ['Portland', 'Salem'],
    'Pennsylvania': ['Philadelphia', 'Pittsburgh'],
    'Rhode Island': ['Providence'],
    'South Carolina': ['Charleston', 'Columbia'],
    'South Dakota': ['Sioux Falls', 'Rapid City'],
    'Tennessee': ['Nashville', 'Memphis'],
    'Texas': ['Austin', 'Houston', 'Dallas', 'San Antonio'],
    'Utah': ['Salt Lake City', 'Provo'],
    'Vermont': ['Burlington', 'Montpelier'],
    'Virginia': ['Arlington', 'Richmond', 'Virginia Beach'],
    'Washington': ['Seattle', 'Bellevue', 'Spokane'],
    'West Virginia': ['Charleston', 'Huntington'],
    'Wisconsin': ['Milwaukee', 'Madison'],
    'Wyoming': ['Cheyenne', 'Jackson'],
  },
  'United Arab Emirates': {
    'Dubai': ['Dubai', 'Jebel Ali', 'Deira'],
    'Abu Dhabi': ['Abu Dhabi', 'Al Ain'],
    'Sharjah': ['Sharjah'],
    'Ajman': ['Ajman'],
    'Umm Al Quwain': ['Umm Al Quwain'],
    'Fujairah': ['Fujairah'],
    'Ras Al Khaimah': ['Ras Al Khaimah'],
  },
  'India': {
    'Andhra Pradesh': ['Visakhapatnam', 'Vijayawada'],
    'Arunachal Pradesh': ['Itanagar'],
    'Assam': ['Guwahati'],
    'Bihar': ['Patna'],
    'Chhattisgarh': ['Raipur'],
    'Delhi': ['New Delhi'],
    'Goa': ['Panaji'],
    'Gujarat': ['Ahmedabad', 'Surat', 'Vadodara'],
    'Haryana': ['Gurugram', 'Faridabad'],
    'Himachal Pradesh': ['Shimla'],
    'Jharkhand': ['Ranchi', 'Jamshedpur'],
    'Karnataka': ['Bengaluru', 'Mysuru'],
    'Kerala': ['Kochi', 'Thiruvananthapuram'],
    'Madhya Pradesh': ['Indore', 'Bhopal'],
    'Maharashtra': ['Mumbai', 'Pune', 'Nagpur'],
    'Manipur': ['Imphal'],
    'Meghalaya': ['Shillong'],
    'Mizoram': ['Aizawl'],
    'Nagaland': ['Kohima'],
    'Odisha': ['Bhubaneswar'],
    'Punjab': ['Chandigarh', 'Ludhiana'],
    'Rajasthan': ['Jaipur', 'Udaipur'],
    'Sikkim': ['Gangtok'],
    'Tamil Nadu': ['Chennai', 'Coimbatore'],
    'Telangana': ['Hyderabad'],
    'Tripura': ['Agartala'],
    'Uttar Pradesh': ['Noida', 'Lucknow', 'Kanpur'],
    'Uttarakhand': ['Dehradun'],
    'West Bengal': ['Kolkata', 'Howrah'],
  },
};

export function formatRevenue(amount, unit) {
  if (!amount) return '—';
  const short = { Thousand: 'K', Million: 'M', Billion: 'B' }[unit] || '';
  return `$${Number(amount).toLocaleString('en-US')}${short}`;
}

function loadPersisted(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}
function savePersisted(key, value) {
  try { localStorage.setItem(key, JSON.stringify(value)); } catch { /* storage unavailable */ }
}
export const customSources = loadPersisted('scodac-custom-sources-v1', []);
export function addSource(name) {
  if (!customSources.includes(name)) {
    customSources.push(name);
    savePersisted('scodac-custom-sources-v1', customSources);
  }
  return name;
}

export const revenueSeries = [
  { month: 'Sep', year: 2025, value: 0 }, { month: 'Oct', year: 2025, value: 0 }, { month: 'Nov', year: 2025, value: 0 },
  { month: 'Dec', year: 2025, value: 0 }, { month: 'Jan', year: 2026, value: 0 }, { month: 'Feb', year: 2026, value: 0 },
  { month: 'Mar', year: 2026, value: 0 }, { month: 'Apr', year: 2026, value: 0 }, { month: 'May', year: 2026, value: 0 },
  { month: 'Jun', year: 2026, value: 0 }, { month: 'Jul', year: 2026, value: 0 }, { month: 'Aug', year: 2026, value: 0 },
];

export const partnerSourcedTrend = [
  { month: 'Mar', count: 0 }, { month: 'Apr', count: 0 }, { month: 'May', count: 0 },
  { month: 'Jun', count: 0 }, { month: 'Jul', count: 0 }, { month: 'Aug', count: 0 },
];

export const cityCoords = {
  Bengaluru: { x: 42, y: 76 }, Mumbai: { x: 26, y: 60 }, Delhi: { x: 44, y: 20 }, Pune: { x: 29, y: 66 },
  Chennai: { x: 49, y: 84 }, Hyderabad: { x: 41, y: 66 }, Ahmedabad: { x: 21, y: 46 },
};

export const stages = ['New lead', 'Qualified', 'Proposal', 'Negotiation', 'Won', 'Lost'];
export const stageColor = { 'New lead': 'neutral', Qualified: 'info', Proposal: 'purple', Negotiation: 'warn', Won: 'pass', Lost: 'fail' };
export const priorityColor = { Critical: 'fail', High: 'warn', Normal: 'info', Low: 'neutral' };
export const partnerStatusColor = { Active: 'pass', 'At risk': 'fail', Onboarding: 'warn' };

export const userById = (team, id) => team.find((u) => u.id === id) || team[0];
export const accountForName = (accounts, name) => accounts.find((a) => a.name === name);
export const contactsFor = (contacts, accountId) => contacts.filter((c) => c.accountId === accountId);
